import { render, staticRenderFns } from "./PageAdminUserProfile.vue?vue&type=template&id=1b206408"
import script from "./PageAdminUserProfile.vue?vue&type=script&lang=js"
export * from "./PageAdminUserProfile.vue?vue&type=script&lang=js"
import style0 from "./PageAdminUserProfile.vue?vue&type=style&index=0&id=1b206408&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports